export const CheckoutStatus = {
  Complete: 'complete',
  KeyReturn: 'keyReturn',
  FrontSupport: 'frontSupport',
} as const
export type CheckoutStatus = (typeof CheckoutStatus)[keyof typeof CheckoutStatus]

import { SearchSetting } from '@/models/search-setting'

export type Message = {
  complete: string
  keyReturn: string
  frontSupport: string
}

export type SettingResponse = {
  searchItems: SearchSetting[]
  message: Message
  surveyQrcodeEnabled: boolean
  tabletCheckoutEnabled: boolean
}
